module.exports = __webpack_public_path__ + "img/patho-H.514a7c16.svg";